/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { LinkedInChatMessageResponseDirection } from './linkedInChatMessageResponseDirection';

/**
 * One DM inside ``ChatDetail.messages``.
 */
export interface LinkedInChatMessageResponse {
  id: string;
  direction: LinkedInChatMessageResponseDirection;
  /** @maxLength 8000 */
  body: string;
  is_inmail?: boolean;
  provider_sent_at: string;
  delivered_at?: string | null;
  read_at?: string | null;
}
